<template>
    <div class="about-initiative-form11">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <h6>Nos conhecendo melhor</h6>

            <b-form-group label="Conte-nos brevemente como sua iniciativa surgiu." label-for="aboutInitiative">
                <b-form-textarea
                    id="aboutInitiative"
                    name="aboutInitiative"
                    v-model="form.aboutInitiative"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['brevemente_surgiu'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['brevemente_surgiu'].value"
                />
            </b-form-group>

            <b-form-group
                label="Contextualize o território onde sua iniciativa atua e nos conte quais são os problemas sociais e ambientais enfrentados."
                label-for="aboutTerritory"
            >
                <b-form-textarea
                    id="aboutTerritory"
                    name="aboutTerritory"
                    v-model="form.aboutTerritory"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['contextualize_territorio'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['contextualize_territorio'].value"
                />
            </b-form-group>

            <b-form-group
                label="Por que a sua iniciativa tem impacto social e melhora significativamente a qualidade de vida da população de baixa renda?"
                label-for="socialImpactMotive"
            >
                <b-form-textarea
                    id="socialImpactMotive"
                    name="socialImpactMotive"
                    v-model="form.socialImpactMotive"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['pq_iniciativa_impacto'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['pq_iniciativa_impacto'].value"
                />
            </b-form-group>

            <b-form-group
                label="Quem são seus principais concorrentes? Qual é o diferencial da sua iniciativa em relação a eles?"
                label-for="mainlyCompetitors"
                v-if="getProfileId === 3"
            >
                <b-form-textarea
                    id="mainlyCompetitors"
                    name="mainlyCompetitors"
                    v-model="form.mainlyCompetitors"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['quem_principais_concorrente'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform && getAuthorizationData && !getAuthorizationData['quem_principais_concorrente'].value
                    "
                />
            </b-form-group>

            <b-form-group
                label="Compartilhe o nome e contato de 03 clientes ou parceiros que possam falar sobre sua iniciativa."
                label-for="clientsPartners"
                v-if="getProfileId === 3"
            >
                <b-form-textarea
                    id="clientsPartners"
                    name="clientsPartners"
                    v-model="form.clientsPartners"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['compartilhe_contato_cliente'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform && getAuthorizationData && !getAuthorizationData['compartilhe_contato_cliente'].value
                    "
                />
            </b-form-group>

            <b-form-group
                label="Indique se sua iniciativa já recebeu algum prêmio ou reconhecimento."
                label-for="aboutPremium"
            >
                <b-form-textarea
                    id="aboutPremium"
                    name="aboutPremium"
                    v-model="form.aboutPremium"
                    placeholder="Descreva aqui."
                    rows="6"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['indique_iniciativa_premio'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="
                        isPlatform && getAuthorizationData && !getAuthorizationData['indique_iniciativa_premio'].value
                    "
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="
                        $router.push({ name: getProfileId === 1 ? 'AboutInitiativeForm10' : 'AboutInitiativeForm9' })
                    "
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button
                        :variant="'secondary'"
                        @click="
                            changeRegisterForm(getProfileId === 1 ? 'AboutInitiativeForm10' : 'AboutInitiativeForm9')
                        "
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="changeRegisterForm('ManagementPlanningForm1')"
                        v-if="abbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :no-close-on-backdrop="true"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AboutInitiativeApi } from '../../api/about-initiative'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const aboutInitiativeApi = new AboutInitiativeApi()

export default {
    components: { WarningMsgModal, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            progress: 55.4,
            initiative: null,
            message: null,
            authorizationData: null,
            isUpdate: false,
            form: {
                aboutInitiative: null,
                aboutTerritory: null,
                socialImpactMotive: null,
                mainlyCompetitors: null,
                clientsPartners: null,
                aboutPremium: null
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        fetchRead() {
            const data = this.receiveData
            this.initiative = data

            this.form.aboutInitiative = data.brevemente_surgiu
            this.form.aboutTerritory = data.contextualize_territorio
            this.form.socialImpactMotive = data.pq_iniciativa_impacto
            this.form.aboutPremium = data.indique_iniciativa_premio
            this.form.mainlyCompetitors = data.quem_principais_concorrente
            this.form.clientsPartners = data.compartilhe_contato_cliente

            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([aboutInitiativeApi.getAboutInitiative()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.initiative = data
                        this.form.aboutInitiative = data.brevemente_surgiu
                        this.form.aboutTerritory = data.contextualize_territorio
                        this.form.socialImpactMotive = data.pq_iniciativa_impacto
                        this.form.aboutPremium = data.indique_iniciativa_premio
                        this.form.mainlyCompetitors = data.quem_principais_concorrente
                        this.form.clientsPartners = data.compartilhe_contato_cliente
                    }
                })
                .catch(error => {
                    this.message = error.response.data.messageh
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.initiative,
                brevemente_surgiu: this.form.aboutInitiative,
                contextualize_territorio: this.form.aboutTerritory,
                pq_iniciativa_impacto: this.form.socialImpactMotive,
                indique_iniciativa_premio: this.form.aboutPremium,
                quem_principais_concorrente: this.form.mainlyCompetitors,
                compartilhe_contato_cliente: this.form.clientsPartners,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? aboutInitiativeApi.updateAboutInitiative(data)
                : aboutInitiativeApi.finishAboutInitiative(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.showModal('warning-modal-ref')
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'ManagementPlanningForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getAboutInitiative(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getProfileId() {
            return this.$store.state.profileId
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./AboutInitiativeForm11-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-about-initiative-forms/AboutInitiativeForm11.vue